import gql from 'graphql-tag'

export const customerOrderDetail = gql`
query customerOrderDetail(
  $orderId: Int!
){
  customerOrderDetail (orderId: $orderId) {
    id
    increment_id
    created_at
    created_at_timestamp
    shipping_method 
    payment_method
    shipping_address {
      region_id
      country_id
      fax
      region
      postcode
      lastname
      street
      city
      email
      telephone
      firstname
      middlename
      company
    }
    items {
      description
      item_price
      name
      options {
        label
        value
      }
      qty
      row_price
      sku
    }
    totals {
      code
      value
    }
  }
}
`

export const updateCustomer = gql`
  mutation updateCustomer(
    $firstname: String
    $lastname: String
    $email: String!
    $password: String
  ) {
    updateCustomer(
      input: {
        firstname: $firstname,
        lastname: $lastname,
        email: $email,
        password: $password
      }
    ) {
      customer {
        id
        firstname
        lastname
        email
      }
    }
  }
`

export const updateCustomerPassword = gql`
  mutation visitureChangeCustomerPassword(
    $currentPassword: String!
    $newPassword: String!
  ) {
    visitureChangeCustomerPassword(
      currentPassword: $currentPassword,
      newPassword: $newPassword
    ) {
      id
      email
    }
  }
`

export const createOrUpdateStoredCreditCard = gql`
  mutation createOrUpdateStoredCreditCard (
    $CardNumber: String!
    $CardExpire: String!
    $CCTypeID: String!
    $IsActive: String!
  ) {
    createOrUpdateStoredCreditCard (
      CardNumber: $CardNumber
      CardExpire: $CardExpire
      CCTypeID: $CCTypeID
      IsActive: $IsActive
    ) {
      message
      error
    }
  }
`

export const getCustomerPaymentTokens = gql`
  query customerPayeezyTokens {
    customerPayeezyTokens {
      items {
        details
        payment_method_code
        public_hash
        type
        token
      }
    }
  }
`
